"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";
export function ClientLayoutWrapper(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const isScoreboard = pathname === "/scoreboard";
  let t1;
  if ($[0] !== isScoreboard) {
    t1 = !isScoreboard && <SiteHeader />;
    $[0] = isScoreboard;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `relative z-10 min-h-screen ${!isScoreboard ? "pt-12 lg:pt-48 pb-8 sm:pb-32" : ""}`;
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <main className={t2} id="main">{children}</main>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isScoreboard) {
    t4 = !isScoreboard && <SiteFooter />;
    $[5] = isScoreboard;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t5 = <>{t1}{t3}{t4}</>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}